<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2 m-0">Create New Lab Submission</p>

  <div class="mt-4">
    <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Analysis Type</label>
    <mat-form-field class="w-full" appearance="outline">
      <mat-select placeholder="Select type" [(ngModel)]="selectedType">
        <mat-option *ngFor="let type of submissionTypes" [value]="type">
          {{type.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex justify-end gap-3 mt-4">
    <button (click)="closeDialog()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="closeDialog(selectedType)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Create</button>
  </div>
</div>
